export const APP_SETTINGS_SLICE_KEY = 'appSettings' as const;
